"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_plugin_image_1 = require("gatsby-plugin-image");
function getCMSImage(data, name, noEmitError) {
    var _a;
    const image = data.nodes.find(i => i.data.Name === name);
    if (image === null || image === void 0 ? void 0 : image.data.Image) {
        const sources = (0, gatsby_plugin_image_1.getImage)(image.data.Image.localFiles[0]);
        const url = (_a = image.data.Image.localFiles[0].childImageSharp.gatsbyImageData.images
            .fallback) === null || _a === void 0 ? void 0 : _a.src;
        const alt = image === null || image === void 0 ? void 0 : image.data.Text;
        if (sources && alt)
            return { sources, alt, url };
    }
    if (noEmitError)
        return undefined;
    throw new Error(`Image ${name} not found in ` +
        `Airtable. Does the query include the ` +
        `right tables, and does one of those ` +
        `tables include a section called ${name}?.`);
}
exports.default = getCMSImage;
//# sourceMappingURL=getCMSImage.js.map